import { Fade } from 'transitions-kit';
import css from './search.module.scss';

interface Props {
    search: string;
    onSearch: (value: string) => void;
}
export function Search({ search, onSearch }: Props) {
    return (
        <>
            <span>Feature flags</span>

            <div className={css.wrapper}>
                <input
                    id="search"
                    value={search}
                    autoComplete="off"
                    onChange={e => onSearch(e.target.value)}
                    placeholder="Search by experiment key"
                    className={css.search}
                />
                <Fade in={!!search}>
                    <button className={css.reset} onClick={() => onSearch('')}>
                        ×
                    </button>
                </Fade>
            </div>
        </>
    );
}
